import React from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { connect } from 'react-redux'
import { showModal } from '../../redux/actions/uiActions'

const ViewButton = ({ path, slug: title, showModal, nss }) => {
  return(
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Ver documento</strong>
        </Tooltip>
      }
    >
      <Button onClick={ () => showModal(title, path, nss)}>
        <i className=" fa fa-eye"></i>
      </Button>
    </OverlayTrigger>
      
  )
}

export default connect(null,{showModal})(ViewButton)